"use strict";
exports.__esModule = true;
//# sourceMappingURL=pms-pos.type.js.map